import { render, staticRenderFns } from "./DiscountCoupon.vue?vue&type=template&id=84650096&scoped=true"
import script from "./DiscountCoupon.vue?vue&type=script&lang=js"
export * from "./DiscountCoupon.vue?vue&type=script&lang=js"
import style0 from "./DiscountCoupon.vue?vue&type=style&index=0&id=84650096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84650096",
  null
  
)

export default component.exports